// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import footerWidget from './js/widgets/footerWidget.js';

// --------------------Events & Business Filters----------------------//

import { modifyBusinesses, modifyEvents } from './js/handlers/customFilters.js';

// --------------------Custom Media Container----------------------//

import { customMediaContainer } from './js/widgets/customMediaContainer.js';
// Custom Theme Scripts
import './js/localjs.js';
import './js/handlers/mobileMenuHandler.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlider();
    cardsWidget();
    seoWidget();
    eventsWidget();
  });
} else {
  $(window).on('load', function () {
    modifyBusinesses();
    modifyEvents();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  footerWidget();
  customMediaContainer();
});
